export const SET_CENTRALIZED_ISSUES = 'SET_CENTRALIZED_ISSUES';
export const CLEAR_CENTRALIZED_ISSUES = 'CLEAR_CENTRALIZED_ISSUES';
export const SET_ISSUES_LIST_LOADING = 'SET_ISSUES_LIST_LOADING';
export const SET_DASHBOARD_ISSUES_LIST_LOADING = 'SET_DASHBOARD_ISSUES_LIST_LOADING';
export const SET_PROJECT_ISSUES_LIST_LOADING = 'SET_PROJECT_ISSUES_LIST_LOADING';
export const SET_CENTRALIZED_ISSUES_LIST_OPTIONS = 'SET_CENTRALIZED_ISSUES_LIST_OPTIONS';
export const SET_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW = 'SET_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW';
export const CLEAR_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW = 'CLEAR_ISSUE_DETAILS_FOR_CENTRALIZED_VIEW';
export const CLEAR_CENTRALIZED_ISSUES_LIST_OPTIONS = 'CLEAR_CENTRALIZED_ISSUES_LIST_OPTIONS';
export const SET_ISSUES_FOR_PROJECT = 'SET_ISSUES_FOR_PROJECT';
export const CLEAR_ISSUES_FOR_PROJECT = 'CLEAR_ISSUES_FOR_PROJECT';
export const SET_OPEN_DETAILED_ISSUES_POPUP = 'SET_OPEN_DETAILED_ISSUES_POPUP';
export const CLEAR_OPEN_DETAILED_ISSUES_POPUP = 'CLEAR_OPEN_DETAILED_ISSUES_POPUP';
export const SET_CENTRALIZED_ISSUES_FOR_DASHBOARD = 'SET_CENTRALIZED_ISSUES_FOR_DASHBOARD';
export const CLEAR_CENTRALIZED_ISSUES_FOR_DASHBOARD = 'CLEAR_CENTRALIZED_ISSUES_FOR_DASHBOARD';
export const SET_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS = 'SET_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS';
export const CLEAR_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS = 'CLEAR_CENTRALIZED_ISSUES_FOR_PROJECT_DETAILS';
export const SET_ISSUES_REF_ID = 'SET_ISSUES_REF_ID';
export const CLEAR_ISSUES_REF_ID = 'CLEAR_ISSUES_REF_ID';
export const SET_ISSUES_RUNNING_INTERVAL = 'SET_ISSUES_RUNNING_INTERVAL';
export const SET_ISSUES_PROGRESS = 'SET_ISSUES_PROGRESS';
export const CLEAR_ISSUES_PROGRESS = 'CLEAR_ISSUES_PROGRESS';
export const SET_DASHBOARD_ISSUES_REF_ID = 'SET_DASHBOARD_ISSUES_REF_ID';
export const CLEAR_DASHBOARD_ISSUES_REF_ID = 'CLEAR_DASHBOARD_ISSUES_REF_ID';
export const SET_DASHBOARD_ISSUES_RUNNING_INTERVAL = 'SET_DASHBOARD_ISSUES_RUNNING_INTERVAL';
export const SET_DASHBOARD_ISSUES_PROGRESS = 'SET_DASHBOARD_ISSUES_PROGRESS';
export const CLEAR_DASHBOARD_ISSUES_PROGRESS = 'CLEAR_DASHBOARD_ISSUES_PROGRESS';
export const SET_PROJECT_ISSUES_REF_ID = 'SET_PROJECT_ISSUES_REF_ID';
export const CLEAR_PROJECT_ISSUES_REF_ID = 'CLEAR_PROJECT_ISSUES_REF_ID';
export const SET_PROJECT_ISSUES_RUNNING_INTERVAL = 'SET_PROJECT_ISSUES_RUNNING_INTERVAL';
export const SET_PROJECT_ISSUES_PROGRESS = 'SET_PROJECT_ISSUES_PROGRESS';
export const CLEAR_PROJECT_ISSUES_PROGRESS = 'CLEAR_PROJECT_ISSUES_PROGRESS';
